<template>
  <div class="emoji-search">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>Emoji 表情搜索</span>
      </div>
      <el-input
        v-model="keyword"
        placeholder="输入关键词搜索emoji，如: happy, 笑, 食物"
        clearable
        @input="searchEmoji"
        style="margin-bottom: 20px">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      
      <div v-if="keyword" class="emoji-grid">
        <div 
          v-for="(emoji, index) in filteredEmojis" 
          :key="index"
          class="emoji-item"
          @click="copyEmoji(emoji)">
          <span class="emoji-char">{{ emoji.char }}</span>
          <span class="emoji-name">{{ emoji.name }}</span>
        </div>
      </div>
      
      <div v-if="keyword && filteredEmojis.length === 0" class="no-result">
        <el-empty description="没有找到相关的emoji"></el-empty>
      </div>

      <div v-if="!keyword" class="popular-emojis">
        <h3>常用emoji</h3>
        <div class="emoji-grid">
          <div 
            v-for="(emoji, index) in popularEmojis" 
            :key="index"
            class="emoji-item"
            @click="copyEmoji(emoji)">
            <span class="emoji-char">{{ emoji.char }}</span>
            <span class="emoji-name">{{ emoji.name }}</span>
          </div>
        </div>
      </div>

      <el-alert
        v-if="copySuccess"
        title="已复制到剪贴板!"
        type="success"
        :closable="false"
        style="margin-top: 20px">
      </el-alert>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'emoji',
  data () {
    return {
      keyword: '',
      copySuccess: false,
      popularEmojis: [
        { char: '😀', name: '笑脸' },
        { char: '😂', name: '笑哭' },
        { char: '🤣', name: '笑到哭' },
        { char: '😊', name: '微笑' },
        { char: '😇', name: '天使' },
        { char: '🙂', name: '咧嘴' },
        { char: '😉', name: '眨眼' },
        { char: '😍', name: '花痴' },
        { char: '🥰', name: '爱心' },
        { char: '😘', name: '飞吻' },
        { char: '😎', name: '墨镜' },
        { char: '🤔', name: '思考' },
        { char: '👍', name: '点赞' },
        { char: '👎', name: '差评' },
        { char: '👏', name: '鼓掌' },
        { char: '🙌', name: '庆祝' },
        { char: '🎉', name: '派对' },
        { char: '🔥', name: '火热' },
        { char: '💯', name: '满分' },
        { char: '❤️', name: '红心' },
        { char: '⭐', name: '星星' },
        { char: '✨', name: '闪亮' },
        { char: '🎯', name: '目标' },
        { char: '🚀', name: '火箭' },
        { char: '💪', name: '肌肉' },
        { char: '🤝', name: '握手' },
        { char: '👋', name: '挥手' },
        { char: '🙏', name: '祈祷' },
        { char: '💼', name: '工作' },
        { char: '📱', name: '手机' },
        { char: '💻', name: '电脑' },
        { char: '☕', name: '咖啡' },
        { char: '🍕', name: '披萨' },
        { char: '🍜', name: '面条' },
        { char: '🎮', name: '游戏' },
        { char: '🎵', name: '音乐' },
        { char: '📚', name: '书籍' },
        { char: '🏠', name: '房子' },
        { char: '🚗', name: '汽车' }
      ],
      emojiDatabase: [
        // 笑脸与情感
        { char: '😀', name: '笑脸', keywords: ['笑', 'happy', 'smile'] },
        { char: '😃', name: '大笑', keywords: ['笑', '开心', 'happy', 'big smile'] },
        { char: '😄', name: '欢笑', keywords: ['笑', '开心', 'happy', 'laugh'] },
        { char: '😁', name: '偷笑', keywords: ['笑', '偷笑', 'beam'] },
        { char: '😅', name: '苦笑', keywords: ['笑', '尴尬', 'sweat'] },
        { char: '😂', name: '笑哭', keywords: ['哭', '笑哭', 'laugh cry', 'tears'] },
        { char: '🤣', name: '笑到哭', keywords: ['笑', '疯狂', 'rolling on the floor laughing'] },
        { char: '😊', name: '微笑', keywords: ['笑', '开心', '微笑', 'blush'] },
        { char: '😇', name: '天使', keywords: ['天使', '善良', 'angel'] },
        { char: '🙂', name: '咧嘴', keywords: ['微笑', 'slight smile'] },
        { char: '😉', name: '眨眼', keywords: ['眨眼', 'wink'] },
        { char: '😍', name: '花痴', keywords: ['爱', '喜欢', 'heart eyes'] },
        { char: '🥰', name: '爱心', keywords: ['爱', '喜欢', 'hearts'] },
        { char: '😘', name: '飞吻', keywords: ['吻', '爱情', 'kissing heart'] },
        { char: '😋', name: '流口水', keywords: ['吃', '馋', 'yum'] },
        { char: '😎', name: '墨镜', keywords: ['酷', '墨镜', 'cool'] },
        { char: '🤔', name: '思考', keywords: ['想', '思考', 'think'] },
        { char: '🤨', name: '质疑', keywords: ['质疑', 'raised eyebrow'] },
        { char: '😐', name: '面无表情', keywords: ['中性', 'neutral'] },
        { char: '😑', name: '无表情', keywords: ['无语', 'expressionless'] },
        { char: '😶', name: '闭嘴', keywords: ['闭嘴', 'quiet'] },
        { char: '😏', name: '得意', keywords: ['得意', 'smirk'] },
        { char: '😒', name: '郁闷', keywords: ['郁闷', 'unamused'] },
        { char: '🙄', name: '翻白眼', keywords: ['无语', 'eye roll'] },
        { char: '😬', name: '咧嘴', keywords: ['尴尬', 'grimace'] },
        { char: '😌', name: '放心', keywords: ['放松', 'relieved'] },
        { char: '😔', name: '沮丧', keywords: ['难过', 'sad', 'pensive'] },
        { char: '😷', name: '生病', keywords: ['生病', 'sick'] },
        { char: '🤒', name: '发烧', keywords: ['生病', 'sick', 'thermometer'] },
        { char: '🤕', name: '受伤', keywords: ['受伤', 'injured'] },
        { char: '😵', name: '眩晕', keywords: ['晕', 'dizzy'] },
        { char: '🤯', name: '爆炸', keywords: ['震惊', 'exploding head'] },
        { char: '😱', name: '惊恐', keywords: ['害怕', 'fear', 'scream'] },
        { char: '😴', name: '睡觉', keywords: ['睡', 'sleep'] },
        { char: '🤭', name: '偷笑', keywords: ['笑', 'giggle'] },
        { char: '😈', name: '恶魔', keywords: ['恶魔', 'devil'] },
        // 手势
        { char: '👍', name: '点赞', keywords: ['点赞', '好', 'thumbs up'] },
        { char: '👎', name: '差评', keywords: ['差评', '差', 'thumbs down'] },
        { char: '👏', name: '鼓掌', keywords: ['鼓掌', 'clap'] },
        { char: '🙌', name: '庆祝', keywords: ['庆祝', 'hands'] },
        { char: '🤝', name: '握手', keywords: ['握手', '合作', 'handshake'] },
        { char: '👋', name: '挥手', keywords: ['挥手', 'hello', 'bye'] },
        { char: '🙏', name: '祈祷', keywords: ['祈祷', '谢谢', 'please', 'thank you'] },
        { char: '✌️', name: '胜利', keywords: ['胜利', 'v', 'peace'] },
        { char: '🤞', name: '保佑', keywords: ['好运', 'crossed fingers'] },
        { char: '👌', name: 'OK', keywords: ['好', 'ok', 'perfect'] },
        { char: '✋', name: '举手', keywords: ['举手', 'hand'] },
        { char: '🤙', name: '打电话', keywords: ['电话', 'call'] },
        { char: '💪', name: '肌肉', keywords: ['加油', 'strong'] },
        // 物品
        { char: '💼', name: '工作', keywords: ['工作', '公文包', 'briefcase'] },
        { char: '📱', name: '手机', keywords: ['手机', 'phone'] },
        { char: '💻', name: '电脑', keywords: ['电脑', 'laptop'] },
        { char: '⌨️', name: '键盘', keywords: ['键盘', 'keyboard'] },
        { char: '🖥️', name: '显示器', keywords: ['电脑', 'desktop'] },
        { char: '🖱️', name: '鼠标', keywords: ['鼠标', 'mouse'] },
        { char: '☎️', name: '电话', keywords: ['电话', 'telephone'] },
        { char: '📧', name: '邮件', keywords: ['邮件', 'email'] },
        { char: '📁', name: '文件夹', keywords: ['文件', 'folder'] },
        { char: '📂', name: '打开文件夹', keywords: ['文件', 'open folder'] },
        { char: '📝', name: '笔记', keywords: ['笔记', 'note'] },
        { char: '📌', name: '图钉', keywords: ['图钉', 'pin'] },
        { char: '📎', name: '回形针', keywords: ['夹子', 'paperclip'] },
        { char: '🔗', name: '链接', keywords: ['链接', 'link'] },
        { char: '📎', name: '回形针', keywords: ['附件', 'paperclip'] },
        // 食物
        { char: '🍕', name: '披萨', keywords: ['食物', 'pizza'] },
        { char: '🍔', name: '汉堡', keywords: ['食物', '汉堡', 'burger'] },
        { char: '🍟', name: '薯条', keywords: ['食物', '薯条', 'fries'] },
        { char: '🌭', name: '热狗', keywords: ['食物', '热狗', 'hotdog'] },
        { char: '🍜', name: '面条', keywords: ['食物', '面', 'noodle'] },
        { char: '🍝', name: '意大利面', keywords: ['食物', '意面', 'pasta'] },
        { char: '🍣', name: '寿司', keywords: ['食物', '寿司', 'sushi'] },
        { char: '🍱', name: '便当', keywords: ['食物', '便当', 'bento'] },
        { char: '🍚', name: '米饭', keywords: ['食物', '饭', 'rice'] },
        { char: '🍛', name: '咖喱饭', keywords: ['食物', '咖喱', 'curry'] },
        { char: '🥗', name: '沙拉', keywords: ['食物', '沙拉', 'salad'] },
        { char: '🍰', name: '蛋糕', keywords: ['食物', '蛋糕', 'cake'] },
        { char: '🧁', name: '杯子蛋糕', keywords: ['食物', '蛋糕', 'cupcake'] },
        { char: '🍪', name: '饼干', keywords: ['食物', '饼干', 'cookie'] },
        { char: '🍩', name: '甜甜圈', keywords: ['食物', 'donut'] },
        { char: '🍫', name: '巧克力', keywords: ['食物', '巧克力', 'chocolate'] },
        { char: '🍬', name: '糖果', keywords: ['食物', '糖果', 'candy'] },
        { char: '🍭', name: '棒棒糖', keywords: ['食物', '糖果', 'lollipop'] },
        { char: '☕', name: '咖啡', keywords: ['饮料', '咖啡', 'coffee'] },
        { char: '🍵', name: '茶', keywords: ['饮料', '茶', 'tea'] },
        { char: '🧃', name: '果汁', keywords: ['饮料', '果汁', 'juice'] },
        { char: '🥤', name: '饮料', keywords: ['饮料', 'drink'] },
        { char: '🍺', name: '啤酒', keywords: ['酒', '啤酒', 'beer'] },
        { char: '🍷', name: '红酒', keywords: ['酒', 'wine'] },
        { char: '🥂', name: '香槟', keywords: ['酒', '香槟', 'champagne'] },
        { char: '🍾', name: '庆祝酒', keywords: ['酒', '庆祝', 'party'] },
        // 活动
        { char: '🎉', name: '派对', keywords: ['庆祝', '派对', 'party'] },
        { char: '🎊', name: '彩带球', keywords: ['庆祝', 'confetti'] },
        { char: '🎈', name: '气球', keywords: ['庆祝', '气球', 'balloon'] },
        { char: '🎁', name: '礼物', keywords: ['礼物', 'gift'] },
        { char: '🎀', name: '蝴蝶结', keywords: ['礼物', 'ribbon'] },
        { char: '🎭', name: '面具', keywords: ['表演', 'mask'] },
        { char: '🎨', name: '画笔', keywords: ['艺术', 'art'] },
        { char: '🎬', name: '电影', keywords: ['电影', 'clapper'] },
        { char: '🎤', name: '麦克风', keywords: ['唱歌', 'mic'] },
        { char: '🎧', name: '耳机', keywords: ['音乐', '耳机', 'headphone'] },
        { char: '🎵', name: '音符', keywords: ['音乐', 'music'] },
        { char: '🎶', name: '音乐', keywords: ['音乐', 'musical notes'] },
        { char: '🎹', name: '钢琴', keywords: ['音乐', '钢琴', 'piano'] },
        { char: '🎮', name: '游戏', keywords: ['游戏', 'game'] },
        { char: '🕹️', name: '摇杆', keywords: ['游戏', 'joystick'] },
        { char: '🎯', name: '目标', keywords: ['目标', 'dart'] },
        { char: '🏆', name: '奖杯', keywords: ['胜利', '奖杯', 'trophy'] },
        { char: '🏅', name: '奖牌', keywords: ['胜利', '奖牌', 'medal'] },
        { char: '⚽', name: '足球', keywords: ['运动', '足球', 'soccer'] },
        { char: '🏀', name: '篮球', keywords: ['运动', '篮球', 'basketball'] },
        { char: '🏈', name: '橄榄球', keywords: ['运动', '橄榄球', 'football'] },
        { char: '⚾', name: '棒球', keywords: ['运动', '棒球', 'baseball'] },
        { char: '🎾', name: '网球', keywords: ['运动', '网球', 'tennis'] },
        // 符号
        { char: '🔥', name: '火热', keywords: ['热', '火', 'fire'] },
        { char: '💯', name: '满分', keywords: ['完美', '100'] },
        { char: '❤️', name: '红心', keywords: ['爱', '红心', 'heart'] },
        { char: '💔', name: '心碎', keywords: ['心碎', 'broken heart'] },
        { char: '❣️', name: '心形', keywords: ['爱', 'heart exclamation'] },
        { char: '💕', name: '双心', keywords: ['爱', 'two hearts'] },
        { char: '💖', name: '闪耀心', keywords: ['爱', 'sparkling heart'] },
        { char: '💗', name: '成长心', keywords: ['爱', 'growing heart'] },
        { char: '💓', name: '跳动心', keywords: ['爱', 'beating heart'] },
        { char: '💞', name: '旋转心', keywords: ['爱', 'revolving hearts'] },
        { char: '💘', name: '丘比特心', keywords: ['爱', 'heart with arrow'] },
        { char: '💝', name: '礼物心', keywords: ['爱', 'heart with ribbon'] },
        { char: '⭐', name: '星星', keywords: ['星', 'star'] },
        { char: '🌟', name: '闪星', keywords: ['星', 'glowing star'] },
        { char: '✨', name: '闪亮', keywords: ['闪', 'sparkles'] },
        { char: '💫', name: '流星', keywords: ['星', 'dizzy star'] },
        { char: '⚡', name: '闪电', keywords: ['电', '闪电', 'lightning'] },
        { char: '💥', name: '爆炸', keywords: ['爆', 'explosion'] },
        { char: '💢', name: '怒气', keywords: ['生气', 'anger'] },
        { char: '💨', name: '快跑', keywords: ['跑', 'dash'] },
        { char: '💦', name: '水滴', keywords: ['汗', 'sweat'] },
        { char: '🌈', name: '彩虹', keywords: ['彩虹', 'rainbow'] },
        { char: '☀️', name: '太阳', keywords: ['太阳', 'sun'] },
        { char: '🌙', name: '月亮', keywords: ['月亮', 'moon'] },
        { char: '⭐', name: '星星', keywords: ['星星', 'star'] },
        { char: '🌸', name: '樱花', keywords: ['花', 'cherry blossom'] },
        { char: '🌺', name: '芙蓉', keywords: ['花', 'hibiscus'] },
        { char: '🌻', name: '向日葵', keywords: ['花', 'sunflower'] },
        { char: '🌹', name: '玫瑰', keywords: ['花', 'rose'] },
        { char: '💐', name: '花束', keywords: ['花', 'bouquet'] },
        { char: '🌵', name: '仙人掌', keywords: ['植物', 'cactus'] },
        { char: '🌴', name: '棕榈树', keywords: ['植物', 'palm'] },
        { char: '🌲', name: '大树', keywords: ['植物', 'tree'] },
        { char: '🌳', name: '树', keywords: ['植物', 'deciduous tree'] },
        // 交通
        { char: '🚗', name: '汽车', keywords: ['车', 'car'] },
        { char: '🚕', name: '出租车', keywords: ['车', 'taxi'] },
        { char: '🚙', name: 'SUV', keywords: ['车', 'suv'] },
        { char: '🚌', name: '公交车', keywords: ['车', 'bus'] },
        { char: '🚎', name: '电车', keywords: ['车', 'trolleybus'] },
        { char: '🏎️', name: '赛车', keywords: ['车', 'racing car'] },
        { char: '🚓', name: '警车', keywords: ['车', 'police car'] },
        { char: '🚑', name: '救护车', keywords: ['车', 'ambulance'] },
        { char: '🚒', name: '消防车', keywords: ['车', 'fire engine'] },
        { char: '🚐', name: '货车', keywords: ['车', 'minivan'] },
        { char: '🛻', name: '皮卡车', keywords: ['车', 'pickup'] },
        { char: '🚚', name: '卡车', keywords: ['车', 'truck'] },
        { char: '🚂', name: '火车', keywords: ['火车', 'train'] },
        { char: '🚆', name: '地铁', keywords: ['地铁', 'train'] },
        { char: '✈️', name: '飞机', keywords: ['飞机', 'airplane'] },
        { char: '🚀', name: '火箭', keywords: ['火箭', 'rocket'] },
        { char: '🛸', name: '飞碟', keywords: ['飞船', 'flying saucer'] },
        { char: '🚁', name: '直升机', keywords: ['飞机', 'helicopter'] },
        { char: '⛵', name: '帆船', keywords: ['船', 'sailboat'] },
        { char: '🚢', name: '轮船', keywords: ['船', 'ship'] },
        { char: '⛴️', name: '渡轮', keywords: ['船', 'ferry'] },
        { char: '🛥️', name: '快艇', keywords: ['船', 'motor boat'] },
        { char: '🚲', name: '自行车', keywords: ['车', 'bicycle'] },
        { char: '🛴', name: '滑板车', keywords: ['车', 'scooter'] },
        { char: '🛵', name: '摩托车', keywords: ['车', 'motorcycle'] },
        // 建筑
        { char: '🏠', name: '房子', keywords: ['房子', 'home'] },
        { char: '🏡', name: '庭院房', keywords: ['房子', 'house with garden'] },
        { char: '🏢', name: '办公楼', keywords: ['建筑', 'office building'] },
        { char: '🏣', name: '邮局', keywords: ['建筑', 'post office'] },
        { char: '🏥', name: '医院', keywords: ['建筑', 'hospital'] },
        { char: '🏦', name: '银行', keywords: ['建筑', 'bank'] },
        { char: '🏨', name: '酒店', keywords: ['建筑', 'hotel'] },
        { char: '🏩', name: '爱情酒店', keywords: ['建筑', 'love hotel'] },
        { char: '🏪', name: '便利店', keywords: ['建筑', 'convenience store'] },
        { char: '🏫', name: '学校', keywords: ['建筑', 'school'] },
        { char: '⛪', name: '教堂', keywords: ['建筑', 'church'] },
        { char: '🕌', name: '清真寺', keywords: ['建筑', 'mosque'] },
        { char: '🛕', name: '寺庙', keywords: ['建筑', 'temple'] },
        { char: '🗼', name: '塔', keywords: ['建筑', 'tower'] },
        { char: '🗽', name: '自由女神', keywords: ['建筑', 'statue of liberty'] },
        { char: '🏰', name: '城堡', keywords: ['建筑', 'castle'] },
        { char: '🏯', name: '日式城堡', keywords: ['建筑', 'japanese castle'] },
        // 天气
        { char: '☀️', name: '晴天', keywords: ['天气', '晴天', 'sunny'] },
        { char: '🌤️', name: '晴转多云', keywords: ['天气', 'partly sunny'] },
        { char: '⛅', name: '多云', keywords: ['天气', '多云', 'cloudy'] },
        { char: '🌥️', name: '阴天', keywords: ['天气', '阴天', 'sun behind cloud'] },
        { char: '🌧️', name: '雨天', keywords: ['天气', '下雨', 'rainy'] },
        { char: '⛈️', name: '雷雨', keywords: ['天气', '雷雨', 'thunder'] },
        { char: '🌩️', name: '雷', keywords: ['天气', '雷', 'lightning'] },
        { char: '🌨️', name: '雪天', keywords: ['天气', '下雪', 'snowy'] },
        { char: '❄️', name: '雪花', keywords: ['天气', '雪', 'snowflake'] },
        { char: '🌈', name: '彩虹', keywords: ['天气', '彩虹', 'rainbow'] },
        { char: '☁️', name: '云', keywords: ['天气', '云', 'cloud'] },
        { char: '🌫️', name: '雾', keywords: ['天气', '雾', 'fog'] },
        // 符号
        { char: '✅', name: '勾选', keywords: ['完成', '对', 'check'] },
        { char: '❌', name: '叉号', keywords: ['错误', '错', 'cross'] },
        { char: '⭕', name: '圆圈', keywords: ['圆', 'circle'] },
        { char: '❗', name: '感叹号', keywords: ['警告', 'warning'] },
        { char: '❓', name: '问号', keywords: ['问题', 'question'] },
        { char: '💡', name: '灯泡', keywords: ['想法', 'idea'] },
        { char: '🔔', name: '铃铛', keywords: ['通知', 'bell'] },
        { char: '🔕', name: '静音', keywords: ['静音', 'no bell'] },
        { char: '📌', name: '图钉', keywords: ['标记', 'pin'] },
        { char: '🔍', name: '放大镜', keywords: ['搜索', 'search'] },
        { char: '🔎', name: '放大镜', keywords: ['搜索', 'magnifying glass'] },
        { char: '🔐', name: '锁', keywords: ['锁', 'lock'] },
        { char: '🔑', name: '钥匙', keywords: ['钥匙', 'key'] },
        { char: '🔒', name: '锁住', keywords: ['锁', 'locked'] },
        { char: '🔓', name: '开锁', keywords: ['锁', 'unlocked'] },
        { char: '⏰', name: '闹钟', keywords: ['闹钟', 'alarm'] },
        { char: '⏱️', name: '秒表', keywords: ['时间', 'stopwatch'] },
        { char: '⏲️', name: '计时器', keywords: ['时间', 'timer'] },
        { char: '⌚', name: '手表', keywords: ['时间', 'watch'] },
        { char: '📻', name: '收音机', keywords: ['收音机', 'radio'] },
        { char: '📺', name: '电视', keywords: ['电视', 'tv'] },
        { char: '📷', name: '相机', keywords: ['相机', 'camera'] },
        { char: '📹', name: '摄像机', keywords: ['相机', 'video camera'] },
        { char: '🎥', name: '电影机', keywords: ['相机', 'movie camera'] },
        { char: '📞', name: '听筒', keywords: ['电话', 'telephone receiver'] },
        { char: '☎️', name: '电话', keywords: ['电话', 'phone'] },
        { char: '📠', name: '传真', keywords: ['传真', 'fax'] },
        { char: '🔋', name: '电池', keywords: ['电池', 'battery'] },
        { char: '🔌', name: '插头', keywords: ['插头', 'electric plug'] }
      ]
    }
  },
  computed: {
    filteredEmojis () {
      if (!this.keyword) {
        return []
      }
      const kw = this.keyword.toLowerCase()
      return this.emojiDatabase.filter(emoji => {
        return emoji.name.toLowerCase().includes(kw) ||
          emoji.keywords.some(k => k.toLowerCase().includes(kw))
      })
    }
  },
  methods: {
    searchEmoji () {
      // 搜索由computed属性处理
    },
    copyEmoji (emoji) {
      this.$copyText(emoji.char).then(() => {
        this.copySuccess = true
        setTimeout(() => {
          this.copySuccess = false
        }, 2000)
      }).catch(() => {
        // 兼容不支持剪贴板的浏览器
        const textarea = document.createElement('textarea')
        textarea.value = emoji.char
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        this.copySuccess = true
        setTimeout(() => {
          this.copySuccess = false
        }, 2000)
      })
    }
  }
}
</script>

<style scoped>
.emoji-search {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}
.box-card {
  max-width: 1400px;
  margin: 0 auto;
}
.emoji-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 10px;
  margin-top: 20px;
}
.emoji-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}
.emoji-item:hover {
  background-color: #f5f7fa;
  transform: scale(1.1);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
.emoji-char {
  font-size: 32px;
  margin-bottom: 5px;
}
.emoji-name {
  font-size: 12px;
  color: #666;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.no-result {
  padding: 40px 0;
}
.popular-emojis h3 {
  margin-bottom: 15px;
  color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/view/emoji.vue